import { gql } from "@/services/httpAdapter";

export const onRetractAllWashouts = gql`
	subscription onRetractAllWashouts($locationId: String, $payPeriodId: String) {
		onRetractAllWashouts(locationId: $locationId, payPeriodId: $payPeriodId) {
			locationId
			commissionCycleId
			payPeriodId
			statusSetBy
			statusSetOn
			positionStatus {
				position
				status
			}
		}
	}
`;
